import { render, staticRenderFns } from "./Vacations.vue?vue&type=template&id=5013dfab&scoped=true&"
import script from "./Vacations.vue?vue&type=script&lang=js&"
export * from "./Vacations.vue?vue&type=script&lang=js&"
import style0 from "./Vacations.vue?vue&type=style&index=0&id=5013dfab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013dfab",
  null
  
)

export default component.exports